import Alert from '@mui/material/Alert';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights.ts';

export function PublisherNotifications() {
  const { t } = useTranslation();
  const { isReportGenerated, isReportError, isGeneratingReport, isDisabled } = useAudienceInsights();

  const handleReloadPage = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <>
      {isReportError && <Alert severity="error">{t('Error occurred during report generation.')}</Alert>}

      {isGeneratingReport && (
        <Alert
          severity="info"
          action={
            <Button color="primary" variant="text" onClick={handleReloadPage}>
              {t('REFRESH PAGE')}
            </Button>
          }
        >
          {t('Report being generated, check back in 10 minutes.')}
        </Alert>
      )}

      {isReportGenerated && !isDisabled && (
        <Alert severity="success">
          {t('Report generated successfully. Now you can select publishers below to check insights.')}
        </Alert>
      )}
    </>
  );
}
